import { all } from 'redux-saga/effects'
import {
  watchGetInvoiceSaga,
  watchSaveAndSendInvoiceSaga,
  watchCopyInvoice,
  watchRemoveInvoiceSaga,
  watchSaveInvoiceDraft,
  watchEditInvoice,
  watchCancelEditInvoice,
  watchGenerateInvoicePDF,
  watchSaveAndSendInvoicePDF,
  watchInvoiceDownloadPDF,
  watchFinvoiceOperators,
  watchInvoiceLocationChangeSaga,
  watchNavigateToUpdateBankInfoSaga,
  watchReminderInvoiceDownloadPDFSaga,
  watchChangeVATPercentSaga,
  watchSelectInvoiceCustomerSaga,
  watchEditAndGoToInvoiceSaga,
  watchGoToInvoiceSaga,
  watchAddExpensesToInvoiceSaga,
  watchAddAllowancesToInvoiceSaga,
  watchAddCreditNoteInvoice,
  watchGetRegisteredUsersListSaga,
  watchGetInvoiceUserEmailSaga,
  watchAttachedWorkShiftJournalIdSaga,
  watchUpdateAttachJournalToInvoiceSaga
} from './invoice.saga'
import {
  watchGetTaxCardSaga,
  watchPostYelSaga,
  watchGetYelSaga,
  watchUpdatePasswordSaga,
  watchGetUserYelInfoSaga,
  watchUpdateTaxCardSaga
} from './tax.saga'
import {
  watchCheckAuthInfoSaga,
  watchCustomersChartSaga,
  watchInvoiceChartSaga,
  watchGetUserTaxInfoSaga,
  watchGetCompanyUpdatesSaga,
  watchGetRenewTokenSaga,
  watchTokenValidationSaga,
  watchSendReferralSaga,
  watchGetReferralDiscountByEmailSaga,
  watchSetReadCompanyUpdateSaga,
  watchGetUserCompanyUpdateInfoSaga,
  watchGetUserLifeTimeInfoSaga,
  watchUpdateCelebrationStatusSaga,
  watchGetSalaryDetailMonthlySaga
} from './dashboard.saga'
import {
  watchLoadProfileSaga,
  watchUpdateProfileSaga,
  watchGetProfession,
  watchGetFieldOfWork,
  watchSaveLogoSaga,
  watchGetLogoSaga,
  watchDeleteLogoSaga,
  watchUpdateUserEmailSaga,
  watchVerifyUserProfile
} from './profile.saga'
import {
  watchAddNewCustomerSaga,
  watchGetCustomersSaga,
  watchGetCustomerByIdSaga,
  watchRemoveCustomerSaga,
  watchSaveCustomerSaga,
  watchGetCustomerToAddInvoiceSaga,
  watchEInvoiceOperators,
  watchCountryListSaga
} from './customer.saga'
import { watchSendRegisterInfoSaga } from './register.saga'
// import { watchLoadRegisterReviewSaga } from './signup.saga'
// import {
//   watchSendContactInfoSaga,
//   watchContactLocationChange
// } from './contact.saga'
import {
  watchAdminInvoiceSearchSaga,
  watchAdminInvoiceExpandSaga,
  watchAdminUsersSearchSaga,
  //watchAdminChangeMenuSaga,
  watchAdminInvoiceUpdateSaga,
  watchAdminUserExpandSaga,
  watchAdminUserUpdateSaga,
  watchAdminWagesSearchSaga,
  watchAdminUpdateInvoiceStatusSaga,
  watchAdminUpdateSalaryStatusSaga,
  watchAdminAddNewUpdatesSaga,
  watchAdminDeleteCompanyUpdateSaga,
  watchAdminGetUpdatesSaga,
  watchAdminNoPikapalkkaSaga,
  watchShowSalaryPDFSaga,
  watchShowInvoicePDFSaga,
  watchAdminUpdateInvoiceStatustoRejectedSaga,
  watchAdminUpdateInvoiceStatustoNewSaga,
  watchAdminUpdateInvoiceStatustoLoanedSaga,
  watchAdminUpdateInvoiceStatustoNotAcceptedSaga,
  watchAdminUpdateInvoiceStatustoPaidAndNewInvoiceSaga,
  watchsentInvoiceReminderSaga,
  watchImportKassavirtanenSalariesSaga,
  watchSalarySendToIRSaga,
  watchcancelSalaryIRReportSaga,
  watchManualPaySalariesSaga,
  watchShowReminderInvoicePDFSaga,
  watchGetAdminExpenseReportSaga,
  watchAdminUpdateInvoiceStatustoPerinnassaSaga,
  watchadminsearchIRSalaryInfoSaga,
  watchupdateSalaryStatusIRSaga,
  watchCancelUpdateAdminSalaryStatus,
  watchSearchCompanyInvoicesSaga,
  watchShowLatestInvoicePDFSaga,
  watchAdminSalaryExpandSaga,
  watchAdminSalaryUpdateSaga,
  watchDownloadCustomersReportSaga,
  watchGetAdminSalaryUlosottoInfo,
  watchSearchCompanySalariesSaga,
  watchSearchCompanyCustomersSaga
} from './admin.saga'
//import { watchRehydrateSaga } from './rehydrate.saga'
import {
  watchGetNewSalarySaga,
  watchSelectRowSalarySaga,
  watchGetSalariesSaga,
  watchPostSalarySaga,
  watchGetSalaryByIdSaga,
  watchSaveSalarySlipSaga,
  watchSendReferralCodeSaga,
  watchDiscountIsNotUsedSaga
} from './salary.saga'
import {
  watchSaveExpenseSaga,
  watchSaveAllowanceSaga,
  watchGetExpenseStartSaga,
  watchLoadAllowanceCostSaga,
  watchRemoveExpenseSaga,
  watchEditExpenseSaga,
  watchRemoveAllowanceSaga,
  watchEditAllowanceSaga,
  watchSaveAllowanceUpdateSaga,
  watchSaveExpenseUpdateSaga,
  watchCancelExpenseUpdateSaga,
  watchAllowanceCalculateDistanceSaga,
  watchUpdateInvoiceIdToExpenseSaga,
  watchUpdateInvoiceIdToAllowanceSaga,
  watchClearAdditionalVehicleInfo,
  watchCopyAllowanceSaga,
  watchCancelAllowanceUpdateSaga
} from './expense.saga'
import {
  watchLoginSaga,
  watchLogoutSaga,
  watchGetLangFromSiteSaga
} from './login.saga'
import { watchChangeLanguageSaga } from './lang.saga'
import { watchResetPasswordSaga } from './resetPassword.saga'
import {
  watchGetUsersList,
  watchSelectUser,
  watchGetUserInfo,
  watchClearSelectedUser
} from './adminUser.saga'
//company details
import {
  watchCompanyDetailsSearch,
  watchLoadSelectedCompanySaga
} from './companyDetails.saga'
import {
  watchLoadOpenForWorkSaga,
  watchUpdateOpenForWorkSaga,
  watchGetAreaOfExpertiseSaga,
  watchGetAreaOfWorkSaga,
  watchNotOpenForWorkSaga,
  watchGetAllAssignmentsSaga,
  watchSearchAssignmentSaga,
  watchSendApplicationSaga,
  watchTrackApplicationSaga,
  watchGetAssignmentOfferedSaga,
  watchRejectAssignmentSaga,
  watchGetApplicationProfileSaga,
  watchSignAndSendAssignmentSaga,
  watchGetWorkshiftUserSaga,
  watchGetBillableHourUserSaga,
  watchUpdateUserWorkshiftSaga,
  watchRequestEditActualHourSaga,
  watchGetEmployerWorkshiftSaga,
  watchGetJournalSaga,
  watchGetJournalEditSaga,
  watchDeleteJournalSaga,
  watchAddJournalDetailSaga,
  watchUpdateJournalSaga,
  watchUpdateViewAssignmentSaga,
  watchPinAssignmentSaga,
  watchUpdateViewApplicationSaga,
  watchPinApplicationSaga,
  watchUpdateViewWorkshiftSaga,
  watchPinWorkShiftSaga
} from './openForWork.saga'

import {
  watchGetIndustryTaxCardSaga,
  watchShipbuildingTaxCardSaga
} from './taxArea.saga'

// Single entry point to start all sagas at once
export default function* rootSaga() {
  try {
    yield all([
      watchGetInvoiceSaga(),
      watchSaveAndSendInvoiceSaga(),
      watchCheckAuthInfoSaga(),
      watchCustomersChartSaga(),
      watchInvoiceChartSaga(),
      watchGetUserTaxInfoSaga(),
      watchGetCompanyUpdatesSaga(),
      watchGetRenewTokenSaga(),
      watchTokenValidationSaga(),
      watchLoadProfileSaga(),
      watchCopyInvoice(),
      watchRemoveInvoiceSaga(),
      watchEditInvoice(),
      watchCancelEditInvoice(),
      watchGetProfession(),
      watchVerifyUserProfile(),

      watchAddNewCustomerSaga(),
      watchGetCustomersSaga(),
      watchGetCustomerByIdSaga(),
      watchRemoveCustomerSaga(),
      watchSaveCustomerSaga(),
      watchGetCustomerToAddInvoiceSaga(),

      watchSaveInvoiceDraft(),
      watchGetTaxCardSaga(),
      watchUpdateTaxCardSaga(),
      watchUpdateProfileSaga(),
      watchAdminInvoiceSearchSaga(),
      watchAdminInvoiceExpandSaga(),
      watchAdminUsersSearchSaga(),
      //watchAdminChangeMenuSaga(),
      //watchRehydrateSaga(),
      watchGetNewSalarySaga(),
      watchAdminInvoiceUpdateSaga(),
      watchAdminUserExpandSaga(),
      watchAdminUserUpdateSaga(),
      watchSaveExpenseSaga(),
      watchGetExpenseStartSaga(),
      watchPostYelSaga(),
      watchSaveAllowanceSaga(),
      watchLoadAllowanceCostSaga(),
      watchGetYelSaga(),
      watchGetUserYelInfoSaga(),
      watchSelectRowSalarySaga(),
      watchGetSalariesSaga(),
      watchPostSalarySaga(),
      watchGetSalaryByIdSaga(),
      watchSendRegisterInfoSaga(),
      watchLoginSaga(),
      watchLogoutSaga(),
      watchGetLangFromSiteSaga(),
      watchRemoveExpenseSaga(),
      watchEditExpenseSaga(),
      watchRemoveAllowanceSaga(),
      watchEditAllowanceSaga(),
      watchSaveSalarySlipSaga(),
      watchSaveAllowanceUpdateSaga(),
      watchSaveExpenseUpdateSaga(),
      watchCancelExpenseUpdateSaga(),
      watchUpdatePasswordSaga(),
      // watchLoadRegisterReviewSaga(),
      // watchSendContactInfoSaga(),
      // watchContactLocationChange(),
      watchChangeLanguageSaga(),
      watchResetPasswordSaga(),
      watchGenerateInvoicePDF(),
      watchSaveAndSendInvoicePDF(),
      watchAdminWagesSearchSaga(),
      watchAdminUpdateInvoiceStatusSaga(),
      watchAdminUpdateSalaryStatusSaga(),
      watchAdminAddNewUpdatesSaga(),
      watchAdminDeleteCompanyUpdateSaga(),
      watchAdminGetUpdatesSaga(),
      watchAdminNoPikapalkkaSaga(),
      watchShowSalaryPDFSaga(),
      watchShowInvoicePDFSaga(),
      watchInvoiceDownloadPDF(),
      watchFinvoiceOperators(),
      watchEInvoiceOperators(),
      watchInvoiceLocationChangeSaga(),
      watchNavigateToUpdateBankInfoSaga(),
      watchReminderInvoiceDownloadPDFSaga(),
      watchAllowanceCalculateDistanceSaga(),
      watchUpdateInvoiceIdToExpenseSaga(),
      watchUpdateInvoiceIdToAllowanceSaga(),
      watchAdminUpdateInvoiceStatustoRejectedSaga(),
      watchAdminUpdateInvoiceStatustoNewSaga(),
      watchAdminUpdateInvoiceStatustoLoanedSaga(),
      watchAdminUpdateInvoiceStatustoNotAcceptedSaga(),
      watchAdminUpdateInvoiceStatustoPaidAndNewInvoiceSaga(),
      watchsentInvoiceReminderSaga(),
      watchImportKassavirtanenSalariesSaga(),
      watchSalarySendToIRSaga(),
      watchcancelSalaryIRReportSaga(),
      watchManualPaySalariesSaga(),
      watchShowReminderInvoicePDFSaga(),
      watchGetAdminExpenseReportSaga(),
      watchAdminUpdateInvoiceStatustoPerinnassaSaga(),
      watchChangeVATPercentSaga(),
      watchGetUsersList(),
      watchSelectUser(),
      watchGetUserInfo(),
      watchClearSelectedUser(),
      watchClearAdditionalVehicleInfo(),
      watchadminsearchIRSalaryInfoSaga(),
      watchupdateSalaryStatusIRSaga(),
      //watchRecoveryInvoiceSaga()
      watchSelectInvoiceCustomerSaga(),
      watchCompanyDetailsSearch(),
      watchLoadSelectedCompanySaga(),
      watchCountryListSaga(),
      watchEditAndGoToInvoiceSaga(),
      watchGoToInvoiceSaga(),
      watchAddExpensesToInvoiceSaga(),
      watchAddAllowancesToInvoiceSaga(),
      watchCancelUpdateAdminSalaryStatus(),
      watchSearchCompanyInvoicesSaga(),
      watchSearchCompanySalariesSaga(),
      watchSearchCompanyCustomersSaga(),
      watchGetFieldOfWork(),
      watchAddCreditNoteInvoice(),
      watchLoadOpenForWorkSaga(),
      watchUpdateOpenForWorkSaga(),
      watchNotOpenForWorkSaga(),
      watchGetAreaOfExpertiseSaga(),
      watchGetAreaOfWorkSaga(),
      watchShowLatestInvoicePDFSaga(),
      watchGetIndustryTaxCardSaga(),
      watchShipbuildingTaxCardSaga(),
      watchSendReferralSaga(),
      watchGetReferralDiscountByEmailSaga(),
      watchSendReferralCodeSaga(),
      watchDiscountIsNotUsedSaga(),
      watchSaveLogoSaga(),
      watchGetLogoSaga(),
      watchDeleteLogoSaga(),
      watchGetAllAssignmentsSaga(),
      watchSearchAssignmentSaga(),
      watchSendApplicationSaga(),
      watchTrackApplicationSaga(),
      watchGetAssignmentOfferedSaga(),
      watchRejectAssignmentSaga(),
      watchGetApplicationProfileSaga(),
      watchSignAndSendAssignmentSaga(),
      watchAdminSalaryExpandSaga(),
      watchAdminSalaryUpdateSaga(),
      watchGetRegisteredUsersListSaga(),
      watchGetInvoiceUserEmailSaga(),
      watchSetReadCompanyUpdateSaga(),
      watchGetUserCompanyUpdateInfoSaga(),
      watchGetUserLifeTimeInfoSaga(),
      watchUpdateCelebrationStatusSaga(),
      watchGetSalaryDetailMonthlySaga(),
      watchGetWorkshiftUserSaga(),
      watchGetBillableHourUserSaga(),
      watchUpdateUserWorkshiftSaga(),
      watchRequestEditActualHourSaga(),
      watchGetEmployerWorkshiftSaga(),
      watchGetJournalSaga(),
      watchGetJournalEditSaga(),
      watchDeleteJournalSaga(),
      watchAddJournalDetailSaga(),
      watchUpdateJournalSaga(),
      watchAttachedWorkShiftJournalIdSaga(),
      watchUpdateAttachJournalToInvoiceSaga(),
      watchGetAdminSalaryUlosottoInfo(),
      watchDownloadCustomersReportSaga(),
      watchDownloadCustomersReportSaga(),
      watchCopyAllowanceSaga(),
      watchCancelAllowanceUpdateSaga(),
      watchUpdateUserEmailSaga(),
      watchUpdateViewAssignmentSaga(),
      watchPinAssignmentSaga(),
      watchUpdateViewApplicationSaga(),
      watchPinApplicationSaga(),
      watchUpdateViewWorkshiftSaga(),
      watchPinWorkShiftSaga()
    ])
  } catch (e) {
    console.error('Error in `rootSaga`: ', e)
  }
}
